import { Component, OnInit, Injector, Input, inject, signal, output, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { BasePage } from '../../services/base-page';
import { jkGlb, JkGlbClass } from '../../services/jkglb';
import { idNameItem } from '../../services/jkInterface';
import { exitApp } from '../../services/jkCommon';
import { jkRestReturnClass } from '../../services/jkClass';
import { JkComboboxComponent } from '../jkcombobox/jkcombobox.component';
import { JkeditComponent } from '../jkedit/jkedit.component';
import { JkcheckboxComponent } from '../jkcheckbox/jkcheckbox.component';
import { PageService } from '../../services/page.service';
import { BiometricAuthService } from '../../services/biometric-auth.service';

@Component({
  standalone: true,
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule, MaterialModule, JkComboboxComponent, JkeditComponent, JkcheckboxComponent]
})
export class LoginFormPage extends BasePage implements OnInit {
  page: PageService;//= inject(PageService);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() error: string = '';
  readonly submitEM = output();

  public userId = signal<string>('');
  public password = signal<string>('');
  public showPass = signal<boolean>(false);
  email = signal<string>('');
  autoLogin = signal<boolean>(false);
  public isLoading = signal<boolean>(false);

  // 生物識別相關屬性
  public biometricSupported = signal<boolean>(false);
  public isMobile = signal<boolean>(false);
  public hasBiometricCredential = signal<boolean>(false);
  public isBiometricLoading = signal<boolean>(false);

  private biometricService!: BiometricAuthService;
  public handlerMessage = 'no message';
  public roleMessage = ' role message';
  //form!: FormGroup;

  //constructor(injector: Injector, public jkGlb: JkGlbClass) {
  constructor() {
    const injector = inject(Injector);

    //const injector = inject(Injector);
    super(injector);
    this.page = inject(PageService);
    this.biometricService = inject(BiometricAuthService);
    //console.log('LoginFormPage companyList:', jkGlb.companyList);
    this.lstCompany = jkGlb.companyList;
    if (this.lstCompany.length > 0) {
      this.companySelected = this.lstCompany[0].id;
    }

    // Move initialization here to prevent ExpressionChangedAfterItHasBeenCheckedError
    this.userId.set(this.login.userid);
    if (this.login.companyListId) {
      this.companySelected = this.login.companyListId;
    }
    this.autoLogin.set(this.login.autoLogin);
  }

  async ngOnInit() {
    // 初始化生物識別功能
    await this.initBiometric();
    // 確保在非同步操作後觸發變更檢測
    //this.cdr.detectChanges();
  }
  getCompany(companySelected: string): idNameItem | undefined {
    let c: idNameItem | undefined = this.lstCompany.find((item) => item.id === companySelected);// = {id:'',name:'',dbname:'',url:''};// = new CompanyClass();
    for (let i = 0; i < this.lstCompany.length; i++) {
      if (this.lstCompany[i].id === companySelected) {
        c = this.lstCompany[i];
        break;
      }
    };
    return c;

  }
  async closePage() {
    // 若有裝 @capacitor/app
    // App.exitApp();
    //const p = await this.platform.platforms;
    exitApp('browser');
    //this.platform.backButton.subscribe(() => {
    //navigator['app'].exitApp();
    //});

  }
  /*
  submit() {
    if (this.form.valid) {
      this.submitEM.emit(this.form.value);
    }
  }*/

  async loginUser() {
    // 清除之前的錯誤訊息
    this.error = '';
    this.isLoading.set(true);

    // 基本驗證
    if (!this.userId().trim()) {
      this.error = '請輸入使用者名稱';
      this.isLoading.set(false);
      return;
    }

    if (!this.password().trim()) {
      this.error = '請輸入密碼';
      this.isLoading.set(false);
      return;
    }

    try {
      let bool = this.login.setCompanyItem(this.getCompany(this.companySelected) || { id: '', name: '', icon: '', ps1: '', ps2: '' }, this.companySelected);
      if (!bool) {
        this.error = '選擇的公司代號(' + this.companySelected + ')不存在!';
        this.isLoading.set(false);
        return;
      }

      let ret = new jkRestReturnClass();
      let loginSuccess = await this.login.logIn(this.userId(), this.email(), this.password(), '', this.autoLogin(), ret);

      if (!loginSuccess) {
        this.error = ret.getResultError() || '登入失敗，請檢查您的帳號密碼';
        //this.cdr.detectChanges();
        this.isLoading.set(false);
        return;
      }

      if (this.isLogin) {
        const returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl');
        // 登入成功，延遲一下讓用戶看到成功狀態
        setTimeout(() => {
          if (this.isSafeReturnUrl(returnUrl)) {
            void this.router.navigateByUrl(returnUrl);
            return;
          }

          this.page.goBack();
        }, 1000);
      } else {
        this.error = ret.getResultError() || '登入失敗';
      }

    } catch (error: any) {
      this.error = '登入過程中發生錯誤，請稍後再試:' + error.message;
      //this.cdr.detectChanges();
    } finally {
      this.isLoading.set(false);
      await this.dismissLoadingView();
    }
  }

  private isSafeReturnUrl(returnUrl: string | null): returnUrl is string {
    return Boolean(returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//'));
  }
  async logout() {

    this.login.logout(this.login.hostName);
  }

  async registerPage() {
    //this.navCtrl.push('RegisterPage'); // push  FIXED: upgrade
    /* #ionic
    await this.showLoadingView({ showOverlay: true });

    const modal = await this.modalCtrl.create({
      component: RegisterPage,//SignInPage,
      componentProps: {
        showLoginForm: true
      },
    });

    await modal.present();

    this.showContentView();
    */
    let msg = 'Dialog under construct';
    alert(msg);
  }

  /**
   * 初始化生物識別功能
   */
  private async initBiometric(): Promise<void> {
    return; // jackie remark
    try {
      this.isMobile.set(this.biometricService.isMobileDevice());
      this.biometricSupported.set(await this.biometricService.isBiometricSupported());

      if (this.biometricSupported() && this.userId() && this.companySelected) {
        this.hasBiometricCredential.set(this.biometricService.hasBiometricCredential(
          this.userId(),
          this.companySelected
        ));
      }
    } catch (error: any) {

      this.error = '初始化生物識別功能失敗:' + error.message;
      this.biometricSupported.set(false);
    }
  }

  /**
   * 註冊生物識別
   */
  async registerBiometric(): Promise<void> {
    if (!this.userId().trim()) {
      this.error = '請先輸入使用者名稱';
      return;
    }

    if (!this.companySelected) {
      this.error = '請先選擇登入公司';
      return;
    }

    this.isBiometricLoading.set(true);
    this.error = '';

    try {
      const success = await this.biometricService.registerBiometric(
        this.userId(),
        this.companySelected
      );

      if (success) {
        this.hasBiometricCredential.set(true);
        alert('生物識別註冊成功！下次可以使用指紋或 Face ID 快速登入。');
      } else {
        this.error = '生物識別註冊失敗';
        //this.cdr.detectChanges();
      }
    } catch (error: any) {
      this.error = '生物識別註冊失敗' + error.message;
      //this.cdr.detectChanges();
    } finally {
      this.isBiometricLoading.set(false);
    }
  }

  /**
   * 使用生物識別登入
   */
  async loginWithBiometric(): Promise<void> {
    if (!this.userId().trim()) {
      this.error = '請先輸入使用者名稱';
      return;
    }

    if (!this.companySelected) {
      this.error = '請先選擇登入公司';
      return;
    }

    this.isBiometricLoading.set(true);
    this.error = '';

    try {
      const biometricSuccess = await this.biometricService.authenticateWithBiometric(
        this.userId(),
        this.companySelected
      );

      if (biometricSuccess) {
        // 生物識別成功後，進行實際的登入流程
        // 這裡可以跳過密碼驗證，或者使用儲存的憑證
        await this.performBiometricLogin();
      } else {
        this.error = '生物識別驗證失敗';
      }
    } catch (error: any) {
      this.error = '生物識別登入失敗:' + error.message;
      //this.cdr.detectChanges();
    } finally {
      this.isBiometricLoading.set(false);
    }
  }

  /**
   * 執行生物識別登入
   */
  private async performBiometricLogin(): Promise<void> {
    try {
      let bool = this.login.setCompanyItem(
        this.getCompany(this.companySelected) || { id: '', name: '', icon: '', ps1: '', ps2: '' },
        this.companySelected
      );

      if (!bool) {
        this.error = '選擇的公司代號(' + this.companySelected + ')不存在!';
        return;
      }

      let ret = new jkRestReturnClass();

      // 對於生物識別登入，我們可以使用特殊的認證方式
      // 這裡假設後端支援生物識別 token 驗證
      let loginSuccess = await this.login.logIn(
        this.userId(),
        this.email(),
        'BIOMETRIC_AUTH', // 特殊密碼標識
        '',
        this.autoLogin(),
        ret
      );

      if (!loginSuccess) {
        this.error = ret.getResultError() || '生物識別登入失敗';
        return;
      }

      if (this.isLogin) {
        // 登入成功
        setTimeout(() => {
          console.log('生物識別登入成功，返回上一頁');
          this.page.goBack();
        }, 1000);
      } else {
        this.error = ret.getResultError() || '登入失敗';
      }

    } catch (error: any) {
      this.error = '登入過程中發生錯誤，請稍後再試:' + error.message;
      //this.cdr.detectChanges();
    }
  }

  /**
   * 移除生物識別憑證
   */
  async removeBiometric(): Promise<void> {
    if (!this.userId().trim() || !this.companySelected) {
      return;
    }

    const confirmed = confirm('確定要移除生物識別憑證嗎？移除後需要重新註冊才能使用生物識別登入。');
    if (!confirmed) {
      return;
    }

    try {
      const success = this.biometricService.removeBiometricCredential(
        this.userId(),
        this.companySelected
      );

      if (success) {
        this.hasBiometricCredential.set(false);
        alert('生物識別憑證已移除');
      } else {
        alert('移除生物識別憑證失敗');
      }
    } catch (error) {
      console.error('移除生物識別憑證錯誤:', error);
      alert('移除生物識別憑證時發生錯誤');
    }
  }

  /**
   * 當使用者或公司選擇改變時，更新生物識別狀態
   */
  onUserOrCompanyChange(): void {
    if (this.biometricSupported() && this.userId() && this.companySelected) {
      this.hasBiometricCredential.set(this.biometricService.hasBiometricCredential(
        this.userId(),
        this.companySelected
      ));
    } else {
      this.hasBiometricCredential.set(false);
    }
  }

}
